import { getUiState } from '../../selectors';
import { IApplicationState } from '../../../types';

export const getGlobalLoaderState = (state: IApplicationState) =>
  getUiState(state).loader;

export const getShowHideLoader = (state: IApplicationState) =>
  getGlobalLoaderState(state).show;
